/**
 * List of frontend-managed capabilities.
 *
 * Note that these are not *all* the possible capabilities, because many are
 * generated dynamically, such as resources CRUD capabilities, and are
 * accessible with the {@link TmrCapabilities} service.
 *
 * @namespace tmrFrontendCapabilities
 * @type {ngConstant}
 */
export const constant = [
  'tmrFrontendCapabilities',
  [
    'Operation.perform',
    'Operation.Encoding.perform',
    'Operation.Encoding.settings',
    'Operation.Inbound.perform',
    'Operation.Inventory.perform',
    'Operation.CycleCount.perform',
    'Operation.Outbound.perform',
    'Operation.Print.perform',
    'Operation.PrintOrderRows.perform',
    'Operation.PrintProductionLots.perform',
    'Operation.PrintProducts.perform',
    'Operation.PrintQueue.perform',
    'Operation.SessionTransferToZone.perform',
    'Operation.TagInfo.perform',
    'Operation.TransferToZone.perform',
    'Operation.PhaseToPhase.perform',
    'Operation.HandheldLocateTag.perform',
    'Operation.HandheldLogout.perform',
    'Operation.HandheldTaggingParty.perform',
    'Operation.RfidUtils.perform',
    'Operation.HandheldKill.perform',
    'Handheld.access',
    'Handheld.Dashboard.access',
    'Handheld.Settings.access',
    'Resource.view',
    'Flag users as administrators',
    'Debug application',
  ],
]
